import { ApiProperty } from "@nestjs/swagger";
import { IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty } from "class-validator";

export class WorkCalenderDto{

    @ApiProperty()
    id: number;

    
    @ApiProperty()
    employeeCode: string;

    
    @ApiProperty()
    date: Date;

    @ApiProperty()
    shift: string;

    @ApiProperty()
    shiftCode: string;

    @ApiProperty()
    workStationTeam: string;

    @ApiProperty()
    inTime:Date;

    @ApiProperty()
    outTime:Date;

    @ApiProperty()
    attendanceStatus: string;

    @ApiProperty()
    leaveCode: string;

    @ApiProperty()
    holiday: boolean;

    @ApiProperty()
    department: string;

    @ApiProperty()
    contractor: string;

    @ApiProperty()
    isActive: boolean;

    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Created User allows maximum 40 characters'})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: "Created User should be only alphabets"})
    createdUser: string;

    updatedAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 40 characters'})
    @Matches(new RegExp('"^(?:[a-zA-Z\\s]|)+$"'), {message: 'Updated User should be only alphabets'})
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;
}